import muster from '@dbk-legacy/muster';
import { getValues } from '@dbk-legacy/muster/utils';
import { variable, redirectOn } from '@dbk-legacy/muster/helpers';
import { Base64 } from 'js-base64';
import Guid from '../utils/guid';
import envConfig from '../../db-env-build';
import DetectBrowser from './app/auth/detectBrowser';
import { ERGON_API_ERROR_CODES, ECREDENTIALS, CHANNEL_TYPES, AUTHORIZATION_ERROR_CODES, FORGOT_PASSWORD_FLOW_STEPS, 
  EBANKINGWEBLUX, APIRESPONSECODES} from '../constants'

export default () => {
  return muster()
    .path('auth.updatePassword', {
      call: async ({ req }, { get, set, call }) => {
        const { seskey, e2eOldPassword, e2eNewPassword, token, changePasswordType } = req.args[0];
        let [userId] = await getValues(get(['auth.userId']));
        const channelInfo = CHANNEL_TYPES.WEB;
        const request = {
          userId,
          seskey,
          e2eOldPassword,
          e2eNewPassword,
          token,
          channel: channelInfo,
          changePasswordType
        }
        const guidStr = Guid();
        const inputParam = Base64.encode(JSON.stringify(request));  
        const [oMessage] = await getValues(get(`roster.data.auth.updatePassword["${inputParam}"]["${guidStr}"]`));

        const parsOMessage = JSON.parse(oMessage);
         
        let oChangePasswordError = parsOMessage.message != "";
        const [messages] = await getValues(get('i18n.messages'));
        await set('auth.passwordUsedError', false);
       
        if (parsOMessage.returnCode === ERGON_API_ERROR_CODES.passwordExpired) {
          oChangePasswordError = true;
          await set('auth.changePasswordError', oChangePasswordError);
          await set('auth.changePasswordErrorMessage', messages['app.forgotPassword.tempPasswordExpiry']);
          await set('auth.changePasswordBusy', false);
          await set('auth.passwordExpired', true);
          return;
        }
        if (parsOMessage.returnCode === ERGON_API_ERROR_CODES.wrongExistingPassword) {
          oChangePasswordError = true;
          await set('auth.changePasswordError', oChangePasswordError);
          await set('auth.changePasswordErrorMessage', messages['app.changepassword.errormsg.wrongExistingPassword']);
          await set('auth.changePasswordBusy', false);
          return;
        } else if (parsOMessage.returnCode === ERGON_API_ERROR_CODES.passwordAlreadyUsed) {
          oChangePasswordError = true;
          await set('auth.passwordUsedError', true);
          await set('auth.changePasswordError', oChangePasswordError);
          await set('auth.changePasswordErrorMessage', messages['app.changepassword.errormsg.passwordAlreadyUsed']);
          await set('auth.changePasswordBusy', false);
          return;
        }

        if (parsOMessage.returnCode === AUTHORIZATION_ERROR_CODES.invalidPassword) {
          oChangePasswordError = true;
          await set('auth.changePasswordError', oChangePasswordError);
          await set('auth.changePasswordErrorMessage', messages['app.changepassword.errormsg.passwordAlreadyUsed']);
          await set('auth.changePasswordBusy', false);
          return;
        }
        const errorMsg = (parsOMessage.returnCode && messages['app.error.errorCode.' + parsOMessage.returnCode]) ? messages['app.error.errorCode.' + parsOMessage.returnCode] : parsOMessage.message;
        await set('auth.changePasswordError', oChangePasswordError);
        await set('auth.changePasswordErrorMessage', errorMsg);
        set('auth.changePasswordBusy', false);

        const [isTempPwdGenerated] = await getValues(get('forgotPassword.generateTempPwdResultValid'));

        if (!oChangePasswordError) {
          const [eCredPwd] = await getValues(get('auth.eCredPwd'));

          if ((eCredPwd && eCredPwd.status) || isTempPwdGenerated) {
            await call('forgotPassword.updateECredStatus', ECREDENTIALS.EPWD_RESET_COMPLETED);
            await set('auth.changePasswordForECred', ECREDENTIALS.EPWD_RESET_COMPLETED);
          }
          isTempPwdGenerated ? await set('forgotPassword.showCurrentStep', FORGOT_PASSWORD_FLOW_STEPS[3]) : await call('ui.history.replace', { pathname: '/change-password-success' });
        }
      }
    })

    .path('password.getEncryptionToken', {
      call: async ({ req }, { get, set, call }) => {

        const { userId, type } = req.args[0];
        if (type === 'login') {
          set('auth.loginBusy', true);
        }
        const ran_str = "random" + Math.round(Math.random() * 1000);
        const sendToFrontEncryptionKey = {};

        let [oReturn] = ""
        if (envConfig.envConfig === EBANKINGWEBLUX) {
          const base64UserId = Base64.encode(userId);
          const inputParam = `${base64UserId}#@#${ran_str}#@#${type}`;

          [oReturn] = await getValues(get(`roster.data.auth.globalAuthEncryptionJsonForLUX["${inputParam}"]`));
        } else {
          [oReturn] = await getValues(get(`roster.data.auth.globalAuthEncryptionJson.${ran_str}.${userId}.${type}`));
        }
        const [messages] = await getValues(get('i18n.messages'));
        if (oReturn && oReturn.$type == "error") {
          await set('auth.invalidLogin', true);
          if (oReturn.value.message.includes(ERROR_CODE_WSO2)) {
            await set('auth.changePasswordError', oChangePasswordError);
            await set('auth.changePasswordErrorMessage', messages['app.login.errorMessage.WSO2IsDown']);  // Error message when wso2 is down
          } else {
            await set('auth.changePasswordError', oChangePasswordError);
            await set('auth.changePasswordErrorMessage', messages['app.login.unableToConnect']);
          }
          await set('auth.changePasswordBusy', false);
          return;
        }

        const oResult = JSON.parse(oReturn);

        if (oResult.returnCode === ERGON_API_ERROR_CODES.invalidCredentials) {
          await set('auth.changePasswordError', true);
          await set('auth.changePasswordErrorMessage', messages['app.auth.invalidLogin']);
          await set('auth.changePasswordBusy', false);
        } else if (oResult.returnCode != 0) {
          await set('auth.changePasswordError', true);
          const errorMessage = oResult.encryptionMSG.$type == "error" || oResult.encryptionMSG == '' ? messages[app.login.error.connectionError] : (oResult.returnCode && messages['app.error.errorCode.' + oResult.returnCode]) ? messages['app.error.errorCode.' + oResult.returnCode] : oResult.encryptionMSG;
          await set('auth.changePasswordErrorMessage', errorMessage);
          set('auth.changePasswordBusy', false);



        } else {

          sendToFrontEncryptionKey.userId = userId;
          sendToFrontEncryptionKey.modulus = oResult.modulus;
          sendToFrontEncryptionKey.exponent = oResult.exponent;
          sendToFrontEncryptionKey.token = oResult.token;
          sendToFrontEncryptionKey.seskey = oResult.seskey;
          sendToFrontEncryptionKey.pwdModeCur = oResult.pwdModeCur;
          sendToFrontEncryptionKey.pwdModeNew = oResult.pwdModeNew;
          sendToFrontEncryptionKey.randnr = oResult.randnr;
          sendToFrontEncryptionKey.pubkey = oResult.pubkey;
          sendToFrontEncryptionKey.keyType = oResult.keyType;

          await set('password.cryptoEncryptedObj', sendToFrontEncryptionKey);

          if (type === 'login') {
            await set('password.cryptoEncryptedObjSuccess', true);
          }
        }
      }
    })

    .path('password.globalauthlogin', {
      call: async ({ req }, { get, set, call }) => {
        // set('auth.loginBusy', true);
        await set('app.user.cacheId', Date.now());
        // await call('auth.resetInfoMessage');

        // const { userId, password, type = "login"} = req.args[0];
        const { userId, password, data, token, randnr, pubkey, seskey, type = "login" } = req.args[0];

        const ran_str = "random" + Math.round(Math.random() * 100);
        const [messages] = await getValues(get('i18n.messages'));

        const check_dot = userId.includes(".");
        if (check_dot) {
          await set('auth.changePasswordError', true);
          await set('auth.changePasswordErrorMessage', messages['app.auth.invalidLogin']);
          await set('auth.changePasswordBusy', false);
          return;
        }

        const encryptedPassword = '';

        let agent = '';
        if (typeof navigator !== 'undefined' && navigator) {
          agent = navigator.userAgent;
        }
        const browserName = DetectBrowser(agent);
        const device = browserName != '' && browserName != null ? 'WEB_' + browserName.name + '_' + browserName.version : '';
        const deviceInfo = device.replace(/\./g, '_');
        const [regionCode] = await getValues(get(['config.regionCode']));

        const oLoginResult = JSON.parse(
            await getValues(get(`roster.data.auth.globalAuthLoginAirLock.${userId}.encrypted-${encryptedPassword}.dummySesKey-${seskey}.token-${token}.cryptoPass-${data}.app-${deviceInfo}.${regionCode}`))
          );

        await Promise.all([
          await set('auth.userId', userId),
          await set('auth.deviceInfo', deviceInfo),
          // await set('auth.authHeader', oLoginResult.authHeader),
          await set('auth.channel', CHANNEL_TYPES.WEB),
          await set('auth.deviceCode', CHANNEL_TYPES.BROWSER),
          await set('auth.eCredPwd', oLoginResult.eCredPwd)
        ]);

        //convert lock out time to seconds/minutes/hours
        function getLockOutTime(millis) {
          const errMsg = messages['app.error.errorCode.1072']
          var n = parseInt(millis) / 1000;
          if (n < 10) {
            n = Math.round(n);
            return messages['app.auth.invalidLogin'];
          } else if (n < 60) {
            n = Math.round(n);
            return errMsg + n + " seconds";
          } else if (n <= 3600) {
            n = Math.round(n / 60);
            return errMsg + n + " minutes";
          } else {
            n = Math.round(n / 3600);
            return errMsg + n + " hours";
          }
        }

        const authSuccess = oLoginResult.authSuccess;
        const tempLockTimeOut = oLoginResult.tempLockTimeOut;
        // TESTING THE user group Client Admin
        // const userGroup = 10;
        console.log("authSuccess is:", authSuccess);
        await set('auth.loginBusy', false);
        const e2eCryptoObj = oLoginResult.e2eCryptoObj;

        if (oLoginResult.returnCode === ERGON_API_ERROR_CODES.user1FAlocked) {
          await set('auth.changePasswordError', true);
          await set('auth.changePasswordErrorMessage', messages['app.error.errorCode.1070']);
          await set('auth.changePasswordBusy', false);
          return;
        }
        if (oLoginResult.returnCode === ERGON_API_ERROR_CODES.invalidCredentials) {
          await set('auth.changePasswordError', true);
          await set('auth.changePasswordErrorMessage', messages['app.auth.invalidLogin']);
          await set('auth.changePasswordBusy', false);
          return;
        }
        // WMCE-459: Reset Password for E-Credentials expired, error message displayed on login
        if (oLoginResult.returnCode === ERGON_API_ERROR_CODES.passwordExpired) {
          await set('auth.changePasswordError', true);
          await set('auth.changePasswordErrorMessage', messages['app.forgotPassword.tempPasswordExpiry']);
          await set('auth.changePasswordBusy', false);
          return;
        }

        //WMCE-11138 APT Fix
        if (oLoginResult.returnCode === ERGON_API_ERROR_CODES.accTempLock) {
          if (tempLockTimeOut) {
            const timeString = await getLockOutTime(tempLockTimeOut);
            await set('auth.changePasswordErrorMessage', timeString);
          } else {
            await set('auth.changePasswordErrorMessage', messages['app.auth.invalidLogin']);
          }
          await set('auth.changePasswordError', true);
          await set('auth.changePasswordBusy', false);
          return;
        }

        await Promise.all([
          set('auth.e2eCryptoObj', e2eCryptoObj),
          set('password.sessionId', oLoginResult.sessionId),  // this is sesKey.
          set('password.authenticateResponse', true)
        ]);
      }
    })

    .path('password.initiateChangePassword', {
      call: async ({ req }, { get, set, call }) => {
        const seskey = req.args[0]; 
        let [userId] = await getValues(get(['auth.userId']));
        const request = {
          userId,
          seskey,
          channel: CHANNEL_TYPES.WEB
        }
        const guidStr = Guid();
        const inputParam = Base64.encode(JSON.stringify(request));
        const [result] = await getValues(get(`roster.data.auth.initiateChangePassword["${inputParam}"]["${guidStr}"]`));
        const parsedData = JSON.parse(result);
        if (parsedData.returnCode === APIRESPONSECODES.success) {
          await set('password.initiateChangePwdResponse', parsedData);
        }
    }})
    
    .path('password.resetVariables', {
      call: async ({ req }, { get, set, call }) => {
        await set('password.initiateChangePwdResponse', null);
        await set('password.authenticateResponse', false);
        await set('password.cryptoEncryptedObj', null);
        await set('password.cryptoEncryptedObjSuccess', false);
        await set('auth.changePasswordBusy', false);
        await set('password.sessionId', null);
    }})
    
    .path('password.cryptoEncryptedObj', variable())
    .path('password.cryptoEncryptedObjSuccess', variable(false))
    .path('password.authenticateResponse', variable())
    .path('password.initiateChangePwdResponse', variable())
    .path('password.sessionId', variable())
}